export default "__VITE_ASSET__4VOZsXS7__"